import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';

@Component({
  selector: 'app-skeleton-match-past',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-match-past.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonMatchPastComponent {
  onlyItem = input<boolean>(false);
  nItems = computed(() =>
    Array.from({ length: this.onlyItem() ? 5 : 10 }, (_, i) => i)
  );
}
